import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0e252029"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "nge-admin-section nge-tutedits" }
const _hoisted_2 = { class: "nge-tutedits-intro" }
const _hoisted_3 = {
  key: 0,
  class: "nge-tutedits-error"
}
const _hoisted_4 = { class: "nge-tutedits-h" }
const _hoisted_5 = { class: "nge-tutedits-count" }
const _hoisted_6 = {
  key: 1,
  class: "nge-tutedits-empty"
}
const _hoisted_7 = { class: "nge-tutedits-where" }
const _hoisted_8 = { class: "nge-tutedits-by" }
const _hoisted_9 = { class: "nge-tutedits-cols" }
const _hoisted_10 = { class: "nge-tutedits-col nge-tutedits-col--old" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-tutedits-label" }, "Now", -1 /* HOISTED */))
const _hoisted_12 = { class: "nge-tutedits-title" }
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "nge-tutedits-col nge-tutedits-col--new" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-tutedits-label" }, "Suggested", -1 /* HOISTED */))
const _hoisted_16 = { class: "nge-tutedits-title" }
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 0,
  class: "nge-tutedits-actions"
}
const _hoisted_19 = ["disabled", "onClick"]
const _hoisted_20 = ["disabled", "onClick"]
const _hoisted_21 = { class: "nge-tutedits-h" }
const _hoisted_22 = { class: "nge-tutedits-count" }
const _hoisted_23 = {
  key: 2,
  class: "nge-tutedits-empty"
}
const _hoisted_24 = { class: "nge-tutedits-where" }
const _hoisted_25 = { class: "nge-tutedits-by" }
const _hoisted_26 = { class: "nge-tutedits-cols" }
const _hoisted_27 = { class: "nge-tutedits-col nge-tutedits-col--old" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-tutedits-label" }, "Original", -1 /* HOISTED */))
const _hoisted_29 = { class: "nge-tutedits-title" }
const _hoisted_30 = ["innerHTML"]
const _hoisted_31 = { class: "nge-tutedits-col nge-tutedits-col--new" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "nge-tutedits-label" }, "Shown", -1 /* HOISTED */))
const _hoisted_33 = { class: "nge-tutedits-title" }
const _hoisted_34 = ["innerHTML"]
const _hoisted_35 = {
  key: 0,
  class: "nge-tutedits-actions"
}
const _hoisted_36 = ["disabled", "onClick"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, "Admins reword a tutorial box with the pencil on it. " + _toDisplayString($setup.approver ? 'Your own edits go straight to players; other admins\' wait here for you.' : 'Your edits wait here until Ames approves them.'), 1 /* TEXT */),
    ($setup.error)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString($setup.error), 1 /* TEXT */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("h3", _hoisted_4, [
      _createTextVNode("Waiting for approval "),
      _createElementVNode("span", _hoisted_5, _toDisplayString($setup.waiting.length), 1 /* TEXT */)
    ]),
    (!$setup.waiting.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_6, "Nothing waiting."))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.waiting, (row) => {
      return (_openBlock(), _createElementBlock("div", {
        key: 'd' + row.tutorial + '.' + row.box,
        class: "nge-tutedits-card"
      }, [
        _createElementVNode("div", _hoisted_7, [
          _createTextVNode(_toDisplayString(row.name) + ", box " + _toDisplayString(row.box + 1) + " ", 1 /* TEXT */),
          _createElementVNode("span", _hoisted_8, _toDisplayString(row.edit.by || 'An admin') + ", " + _toDisplayString($setup.when(row.edit.at)), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _hoisted_11,
            _createElementVNode("div", _hoisted_12, _toDisplayString(row.edit.from.title), 1 /* TEXT */),
            _createElementVNode("div", {
              innerHTML: $setup.html(row.edit.from.words, row.edit.kind)
            }, null, 8 /* PROPS */, _hoisted_13)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, _toDisplayString(row.edit.title), 1 /* TEXT */),
            _createElementVNode("div", {
              innerHTML: $setup.html(row.edit.words, row.edit.kind)
            }, null, 8 /* PROPS */, _hoisted_17)
          ])
        ]),
        ($setup.approver)
          ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
              _createElementVNode("button", {
                type: "button",
                class: "nge-tutedits-btn nge-tutedits-btn--go",
                disabled: !!$setup.busy,
                onClick: $event => ($setup.act(row, 'approve'))
              }, "Approve", 8 /* PROPS */, _hoisted_19),
              _createElementVNode("button", {
                type: "button",
                class: "nge-tutedits-btn",
                disabled: !!$setup.busy,
                onClick: $event => ($setup.act(row, 'reject'))
              }, "Turn down", 8 /* PROPS */, _hoisted_20)
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    }), 128 /* KEYED_FRAGMENT */)),
    _createElementVNode("h3", _hoisted_21, [
      _createTextVNode("What players see now "),
      _createElementVNode("span", _hoisted_22, _toDisplayString($setup.live.length), 1 /* TEXT */)
    ]),
    (!$setup.live.length)
      ? (_openBlock(), _createElementBlock("p", _hoisted_23, "No box has been reworded yet."))
      : _createCommentVNode("v-if", true),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.live, (row) => {
      return (_openBlock(), _createElementBlock("div", {
        key: 'l' + row.tutorial + '.' + row.box,
        class: "nge-tutedits-card"
      }, [
        _createElementVNode("div", _hoisted_24, [
          _createTextVNode(_toDisplayString(row.name) + ", box " + _toDisplayString(row.box + 1) + " ", 1 /* TEXT */),
          _createElementVNode("span", _hoisted_25, _toDisplayString(row.edit.by || 'An admin') + ", " + _toDisplayString($setup.when(row.edit.at)), 1 /* TEXT */)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("div", _hoisted_27, [
            _hoisted_28,
            _createElementVNode("div", _hoisted_29, _toDisplayString(row.edit.from.title), 1 /* TEXT */),
            _createElementVNode("div", {
              innerHTML: $setup.html(row.edit.from.words, row.edit.kind)
            }, null, 8 /* PROPS */, _hoisted_30)
          ]),
          _createElementVNode("div", _hoisted_31, [
            _hoisted_32,
            _createElementVNode("div", _hoisted_33, _toDisplayString(row.edit.title), 1 /* TEXT */),
            _createElementVNode("div", {
              innerHTML: $setup.html(row.edit.words, row.edit.kind)
            }, null, 8 /* PROPS */, _hoisted_34)
          ])
        ]),
        ($setup.approver)
          ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
              _createElementVNode("button", {
                type: "button",
                class: "nge-tutedits-btn",
                disabled: !!$setup.busy,
                onClick: $event => ($setup.act(row, 'restore'))
              }, "Put back the original", 8 /* PROPS */, _hoisted_36)
            ]))
          : _createCommentVNode("v-if", true)
      ]))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}